export const numericSort = (a, b) => {
  return a - b;
};

export const sortBy = (key) => {
  return (a, b) => (a[key] > b[key] ? 1 : b[key] > a[key] ? -1 : 0);
};

export const sortByDesc = (key) => {
  return (a, b) => (b[key] > a[key] ? 1 : a[key] > b[key] ? -1 : 0);
};

export const numericSortBy = (key) => {
  return (a, b) =>
    parseInt(a[key]) > parseInt(b[key])
      ? 1
      : parseInt(b[key]) > parseInt(a[key])
        ? -1
        : 0;
};

export const uniqBy = (arr, predicate) => {
  if (!Array.isArray(arr)) {
    return [];
  }

  const cb = typeof predicate === "function" ? predicate : (o) => o[predicate];

  const pickedObjects = arr
    .filter((item) => item)
    .reduce((map, item) => {
      const key = cb(item);

      if (!key) {
        return map;
      }

      return map.has(key) ? map : map.set(key, item);
    }, new Map())
    .values();

  return [...pickedObjects];
};

export const addTrailingSlash = (theUrl) => {
  return theUrl?.replace(/\/?$/, "/") ?? theUrl;
};

export const arrayRange = (start, stop, step) =>
  Array.from(
    { length: (stop - start) / step + 1 },
    (value, index) => start + index * step
  );

export const htmlEntities = (str) => {
  if (!str || !str?.length) {
    return "";
  }
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
};

export const multiStringDecode = (str) => {
  let decodedStr = str;
  while (decodedStr !== decodeURIComponent(decodedStr)) {
    decodedStr = decodeURIComponent(decodedStr);
  }
  return decodedStr;
};

export const stripHtmlTags = (str) => {
  str = str?.toString() || "";
  return str?.replace(/(<([^>]+)>)/gi, "") || "";
};

export const stripHtmlWithPreserveTags = (
  str,
  preserveTags = ["div", "b", "strong", "a", "h1", "h2", "h3", "h4", "h5", "h6"]
) => {
  str = str?.toString() || "";

  const addClosingTags = preserveTags
    .concat(preserveTags.map((tag) => `/${tag}`))
    .join("|");

  const allowedTagsRegex = new RegExp(`<(?!${addClosingTags}\b)([^>]+)>`, "gi");

  return str.replace(allowedTagsRegex, "") || "";
};

export const formatCurrency = ({ currency = "", amount }) => {
  const currencyCode = currency ?? process.env.GATSBY_PROJECT_CURRENCY ?? "gbp";

  const cleanAmount = typeof amount === "number" ? amount : parseInt(amount);

  if (isNaN(cleanAmount)) {
    return amount;
  }

  const currencyFormat = new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
    currencyDisplay: "code"
  });

  return currencyFormat.format(cleanAmount);
};

export const isValidNumber = (num) => typeof num === "number" && num > 0;
